import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { IntroBanner } from "./components/IntroBanner";
import { Benefits } from "./components/Benefits";
import { HowItWorks } from "./components/HowItWorks";
import { Services } from "./components/Services";
import { Pricing } from "./components/Pricing";
import { Guarantees } from "./components/Guarantees";
import { CTA } from "./components/CTA";
import { Footer } from "./components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length > 1 && document.querySelector(id)) {
        e.preventDefault();
        lenis.scrollTo(id, { offset: -84, duration: 1.2 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#faf7f2]" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <IntroBanner />
        <Benefits />
        <HowItWorks />
        <Services />
        <Pricing />
        <Guarantees />
        <CTA />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}
